import React, { Component } from 'react';
import DataTable from '../../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';

class HistoryGrid extends Component {
    componentWillUnmount() {
        let { updateSelected } = this.props;
        updateSelected({});
    }
    render() {
        let { dataList, updateSelected } = this.props;

        return (
            <DataTable
                columns={[
                    {
                        title: 'Change Date',
                        data: 'changeDateTime'
                    },
                    {
                        title: 'Name',
                        data: 'name'
                    },
                    {
                        title: 'Operation Type (A)dd/(U)pdate',
                        data: 'operationType'
                    },
                    {
                        title: 'Changed By User',
                        data: 'changeByUserName'
                    }
                ]}
                id="historyGrid"
                data={dataList}
                singleSelection
                onSelectedItems={data => {
                    updateSelected(data[0]);
                }}
                columnFormat={[
                    {
                        targets: [0],
                        render: function(data, type, full) {
                            if (data) {
                                let date = new Date(data);
                                return date.toLocaleString('en-US');
                            }
                        }
                    }
                ]}
                rowFormat={(row, data, dataIndex) => {
                    $(row).css('cursor', 'pointer');
                }}
            />
        );
    }
}

HistoryGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    updateSelected: PropTypes.func
};

export default HistoryGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/components/HistoryGrid.js